var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMajorPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 78,
    viewBox: "0 0 64 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7101 22.58H22.2901L9.44006 33.58C8.98552 33.971 8.62135 34.4561 8.37272 35.0017C8.12409 35.5473 7.99694 36.1404 8.00006 36.74V56H36.5901V34.84L34.3401 32.33H41.7101V22.58Z",
    fill: "#EBA183"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.59 37.87H8V56H36.59V37.87Z",
    fill: "#DFE8F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7102 22.58L28.8502 33.58C28.3995 33.9677 28.0376 34.448 27.7891 34.9881C27.5406 35.5282 27.4114 36.1155 27.4102 36.71V56H56.0002V36.74C55.9989 36.1455 55.8697 35.5582 55.6212 35.0181C55.3727 34.478 55.0108 33.9977 54.5602 33.61L41.7102 22.58Z",
    fill: "#CCD8E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.71 40.67C42.9486 40.67 44.1364 41.162 45.0122 42.0378C45.888 42.9136 46.38 44.1014 46.38 45.34V56H37V45.33C37.0013 44.7142 37.1244 44.1047 37.3622 43.5367C37.5999 42.9686 37.9477 42.4532 38.3855 42.0201C38.8232 41.587 39.3423 41.2447 39.9129 41.013C40.4835 40.7813 41.0942 40.6647 41.71 40.67Z",
    fill: "#8D614F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2801 44.58H31.7901C30.9009 44.58 30.1801 45.3008 30.1801 46.19V47.68C30.1801 48.5692 30.9009 49.29 31.7901 49.29H33.2801C34.1693 49.29 34.8901 48.5692 34.8901 47.68V46.19C34.8901 45.3008 34.1693 44.58 33.2801 44.58Z",
    fill: "#BC8169"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.62 44.58H50.13C49.2408 44.58 48.52 45.3008 48.52 46.19V47.68C48.52 48.5692 49.2408 49.29 50.13 49.29H51.62C52.5091 49.29 53.23 48.5692 53.23 47.68V46.19C53.23 45.3008 52.5091 44.58 51.62 44.58Z",
    fill: "#BC8169"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajorPurchase);
export default __webpack_public_path__ + "static/media/major-purchase.d31639b6ddb675171f35677e6aac9ee9.svg";
export { ForwardRef as ReactComponent };